import useFetch from 'elements/Hooks/useFetch'
import { OrdersApi } from '../../../api/Purchase/Orders'
import Supplier from '../../../components/Purchasing/Supplier/Supplier'
import useFetchList from '../../../elements/Hooks/useFetchList'
import useFetchObject from '../../../elements/Hooks/useFetchObject'
import useListCompanyFilter from '../../../elements/Hooks/useListCompanyFilter'
import useModalData from '../../../elements/Hooks/useModalData'
import useTitle from '../../../elements/Hooks/useTitle'
import { get, isEmpty, pick } from 'lodash'
import { handleResponse } from '../../../modules/Utils'
import { withRouter } from 'react-router-dom'
import React from 'react'
import Suppliers from '../../../api/Purchase/Suppliers'
import Members from '../../../api/Members'

const api = new Suppliers()
const memberApi = new Members()

function SupplierCont(props) {
  const key = props.match.params.key

  const { data: supplier = {}, fetch: fetchSupplier, fetching: supplierFetching } = useFetch({
    url: `suppliers/${key}`,
    dependencyArray: [key],
    dontFetch: isEmpty(key),
  })

  const vendor = supplier?.owner
  const { data: member = {}, fetch: fetchMember, fetching: memberFetching } = useFetch({
    url: vendor,
    dependencyArray: [vendor],
    dontFetch: isEmpty(vendor),
  })

  const { list: repsList, fetching: repsListFetching, fetch: fetchRepsList } = useFetchList(
    () => memberApi.representatives.list(member._key).then(handleResponse),
    [member],
    isEmpty(member._key)
  )

  const { list: cachedListOrders, fetching: fetchingOrders, fetch: fetchOrders } = useFetchList(
    () => OrdersApi.list(member._key),
    [member._key],
    isEmpty(member._key)
  )

  function fetch() {
    fetchMember()
    fetchSupplier()
    fetchRepsList()
    fetchOrders()
  }

  const { visible, formRef, onShow: onEdit, onCancel, update, submitting } = useModalData(
    undefined,
    api.update,
    undefined,
    fetch,
    undefined,
    undefined,
    undefined,
    undefined,
    pick(supplier, ['_id', '_rev', '_key'])
  )

  const { list: listOrders, company: companyOrder, onChangeCompany: onChangeCompanyOrder } = useListCompanyFilter(
    cachedListOrders,
    fetchingOrders
  )

  useTitle(get(member, 'fn') || 'Vendor')

  return (
    <Supplier
      {...{
        fetch,
        onEdit,
        onCancel,
        update,
        formRef,
        member,
        supplier,
        repsList,
        fetchMember,
        memberFetching,
        supplierFetching,
        repsListFetching,
        visible,
        submitting,
        cachedListOrders,
        fetchingOrders,
        fetchOrders,
        listOrders,
        companyOrder,
        onChangeCompanyOrder,
      }}
    />
  )
}

SupplierCont.propTypes = {}
SupplierCont.defaultProps = {}

export default withRouter(SupplierCont)
